import ForgotPasswordModal from "./forgot-password-modal";

export default ForgotPasswordModal;
